import { LogOut, Settings } from "lucide-react"

/**
 * Itens do menu dropdown do perfil (footer da sidebar).
 * @type {import("../types/index.js").SidebarUserDropdownItem[]}
 */
export const SIDEBAR_USER_DROPDOWN_ITEMS = [
  {
    id: "configuracao",
    label: "Painel do Administrador",
    icon: Settings,
    href: "/painel-administrador",
    action: "navigate",
    permission: "Configuração",
    actionPermission: "islist",
  },
  {
    id: "logout",
    label: "Sair",
    icon: LogOut,
    action: "logout",
    separatorBefore: true,
  },
]
